import React from 'react'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import { shallowEqual, useSelector } from 'react-redux'
import { minBy } from 'lodash'
import { IconButton, Tooltip } from '@mui/material'
import LaunchRoundedIcon from '@mui/icons-material/LaunchRounded'
import { usedUrl } from 'conf/basepath'

const SeeCmsIconTooltip = () => {
    const {
        cmsCategories,
    } = useSelector(store => ({
        cmsCategories: store.EventsReducer.cmsCategories,
    }), shallowEqual)

    const categoryId = minBy(cmsCategories, cc => cc.id)?.id

    return (
        <Tooltip title={i18n.seeTheCms} placement='right'>
            <IconButton onClick={() => window.open(`${usedUrl}#/contents/${categoryId}`, '_blank').focus()}>
                <LaunchRoundedIcon />
            </IconButton>
        </Tooltip>
    )
}

const SeeCmsCategIconTooltip = () => (
    <Tooltip title={i18n.seeCmsCategories} placement='right'>
        <IconButton onClick={() => window.open(`${usedUrl}#/administration/contents`, '_blank').focus()}>
            <LaunchRoundedIcon />
        </IconButton>
    </Tooltip>
)

const SeeOtherIconTooltip = ({
    title = 'En voir plus',
    link = '',
}) => (
    <Tooltip title={title} placement='right'>
        <IconButton onClick={() => window.open(link, '_blank').focus()}>
            <LaunchRoundedIcon />
        </IconButton>
    </Tooltip>
)

SeeOtherIconTooltip.propTypes = {
    title: PropTypes.string,
    link: PropTypes.string,
}

export {
    SeeCmsIconTooltip,
    SeeCmsCategIconTooltip,
    SeeOtherIconTooltip,
}
